import { render, staticRenderFns } from "./VacationRequestList.vue?vue&type=template&id=cbb547d4"
import script from "./VacationRequestList.vue?vue&type=script&lang=js"
export * from "./VacationRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports